export const fetchBrands = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/brand-master/`);
    if (!response.ok) {
      throw new Error('Failed to fetch brands');
    }
    const data = await response.json();
    return data;
    // Extract brand_name from each brand_details object
    //return data.map(item => item.brand_details.brand_name);
  } catch (error) {
    throw new Error(`API Error: ${error.message}`);
  }
};